import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../controls/ExpandablePanel'
import AdresPrzedsiebiorcy from './AdresPrzedsiebiorcy'
import { ZakupLicencjiDaneDoFakturyStyle } from '../../styles/ZakupLicencjiStyle'
import Progress from '../controls/Progress'
import ErrorDialog from '../ErrorDialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { controlHasError } from '../../lib/errorHandler'

class ZakupLicencjiDaneDoFaktury extends Component {
  gusErrorContent() {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się pobrać danych z serwera GUS.
        </DialogContentText>
        <br />
        <DialogContentText>
          Zweryfikuj wprowadzony NIP i spróbuj ponownie.
        </DialogContentText>
      </DialogContent>
    )
  }

  gusServerErrorContent() {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się pobrać danych z serwera GUS.
        </DialogContentText>
        <br />
        <DialogContentText>
          W chwili obecnej serwer GUS nie odpowiada.
        </DialogContentText>
        <br />
        <DialogContentText>Spróbuj ponownie za chwilę.</DialogContentText>
      </DialogContent>
    )
  }

  render() {
    const {
      data,
      onChangeData,
      onGetGUSData,
      isGUSLoading,
      gusError,
      onCloseGUSErrorDialog,
      validateErrors,
    } = this.props
    return (
      <ZakupLicencjiDaneDoFakturyStyle>
        <div className="medium-headline-5 header">
          Potrzebujemy jeszcze kilku informacji o Twojej firmie, aby móc
          wystawić Ci fakturę
        </div>
        <div>
          <ExpandablePanel title="DANE IDENTYFIKACYJNE" noMargin={true}>
            <form
              name="IdentyfikacjaPodmiotuSkrocona"
              autoComplete="off"
              className="identyfikacjaPodmiotu"
            >
              <div className="firstRow">
                <FormControl
                  component="fieldset"
                  error={controlHasError(validateErrors, 'NIP')}
                >
                  <TextField
                    error={controlHasError(validateErrors, 'NIP')}
                    name="Nip"
                    label="NIP"
                    aria-describedby="nip-error-text"
                    title={data.NIP}
                    value={data.NIP}
                    onChange={e => {
                      onChangeData('NIP', e.target.value)
                    }}
                  />
                  {controlHasError(validateErrors, 'NIP') && (
                    <FormHelperText id="nip-error-text">
                      Pole wymagane
                    </FormHelperText>
                  )}
                </FormControl>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => onGetGUSData(data.NIP)}
                >
                  POBIERZ Z GUS
                </Button>
              </div>
              <FormControl
                component="fieldset"
                error={controlHasError(validateErrors, 'nazwaFirmy')}
              >
                <TextField
                  error={controlHasError(validateErrors, 'nazwaFirmy')}
                  name="NazwaFirmy"
                  label="Nazwa firmy"
                  aria-describedby="nazwa-error-text"
                  title={data.nazwaFirmy}
                  value={data.nazwaFirmy}
                  onChange={e => {
                    onChangeData('nazwaFirmy', e.target.value)
                  }}
                />
                {controlHasError(validateErrors, 'nazwaFirmy') && (
                  <FormHelperText id="nazwa-error-text">
                    Pole wymagane
                  </FormHelperText>
                )}
              </FormControl>
            </form>
          </ExpandablePanel>
          <form />
          <AdresPrzedsiebiorcy
            data={data}
            onChangeData={onChangeData}
            validateErrors={validateErrors}
          />
        </div>
        <Progress
          isOpen={isGUSLoading}
          progressText="Trwa pobieranie danych z GUS..."
        />
        <ErrorDialog
          error={gusError}
          title={'Nie udało się pobrać danych z GUS'}
          content={
            this.props.gusServerError
              ? this.gusServerErrorContent()
              : this.gusErrorContent()
          }
          onCloseDialog={onCloseGUSErrorDialog}
        />
      </ZakupLicencjiDaneDoFakturyStyle>
    )
  }
}

export default ZakupLicencjiDaneDoFaktury
